<template>
  <div class="vilDuVaelge">

    <h1 v-if="$store.getters.bookingInProgress.roomtype === 'vaerelse'">{{ $t('vilDuVaelgeV') }}</h1>
    <h1 v-else-if="$store.getters.bookingInProgress.roomtype === 'moedelokale'">{{ $t('vilDuVaelgeM') }}</h1>

    <div class="flex-container">
      <div><router-link to="vaelgVaerelse"><a class="roomBox">{{$t('ja')}}</a></router-link></div>
      <div><router-link to="ekstra"><a class="roomBox" v-on:click="findFirstRooms($store.getters.availableRooms, $store.getters.bookingInProgress.needs)">{{$t('nej')}}</a></router-link></div>
      <!-- <a class="roomBox" v-on:click="findFirstRooms($store.getters.availableRooms, $store.getters.bookingInProgress.needs)">findFirstRooms</a> -->
    </div>

    <!-- <span>AvailableRooms Antal: {{ Object.keys($store.getters.availableRooms).length }}</span> -->
    <!-- <span>AvailableRooms: {{ $store.getters.availableRooms }}</span> -->

    <!-- <div v-for="room in this.$store.getters.availableRooms" v-bind:key="room.id_room">
      <div>
        id_room: {{room.id_room}} - room desc: {{room.room_desc}}
      </div>
    </div> -->

    <p class="hvisnej">{{$t('hvisnej')}}</p>

      <router-link :to="{name: '5-vaelgType', params: {roomtype: this.$store.getters.bookingInProgress.roomtype, hotel: this.$store.getters.bookingInProgress.hotel, checkin: this.$store.getters.bookingInProgress.startdate, checkout: this.$store.getters.bookingInProgress.enddate} }">
      <div class="tilbage">
          <p>&#171; {{$t('tilbagetekst')}}</p>
      </div>
    </router-link>

  </div>
</template>

<script>
/**
 * Note:
 * Hvis brugeren vælger 'nej' så vælg første ledige værelse i hver kategori der er valgt.
 * Vi har allerede modtaget data om ledige værelser i et axios-kald - brug dette til at vælge 
 * første ledige værelse i hver kategori, på samme måde som hvis brugeren havde valgt dem i 5.2-vaelgVaerelse
 */

export default {
  data () {
    return {
      item: {"test": 2},
    }
  },
  created() {
    this.checkNeeds();  // Kontrollér om der er valgt mindst en værelsestype på forrige side
    this.chooseRooms(); // Find ud af hvilke værelser der er ledige, og spring denne side over hvis der kun kan vælges ét værelse
  },
  mounted() {
  },
  beforeUpdate() {
  },
  methods: {
    chooseRooms() {
      // Start med at lave et axios kald så vi får populeret 'availableRooms'
      this.$store.dispatch("getAvailableRooms", {
        'koncern': this.$route.params.koncern,
        'hotel': this.$store.getters.bookingInProgress.hotel, 
        'start': this.$store.getters.bookingInProgress.startdate, 
        'end': this.$store.getters.bookingInProgress.enddate, 
        'rooms': this.findOrderedRooms(this.$store.getters.bookingInProgress.needs)
      }).then(() => {
        this.skip();  // Kontrollerer om vi skal vise ja/nej-knapperne, eller springe til næste side
        console.log("API loaded...");
        // Loop igennem 'availableRooms' og find første i hver værelsestype
        // Gem de(t) valgt(e) værelse(r)
      })

    },
    // Kontroller om der er valgt mindst én værelsestype på forrige side
    checkNeeds() {
      var needs = this.$store.getters.bookingInProgress.needs;
      var noChoice = 1;
      for(var key in needs) {
        if(needs.hasOwnProperty(key)) {
          if(needs[key] > 0) {
            noChoice--;
          }
        }
      }
      // Hvis der ikke er valgt værelsestype på forrige side så redirect tilbage
      if(noChoice > 0) {
        this.$router.push({path: `vaerelsestype/${this.$store.getters.bookingInProgress.roomtype}/hotel/${this.$store.getters.bookingInProgress.hotel}/checkin/${this.$store.getters.bookingInProgress.startdate}/checkout/${this.$store.getters.bookingInProgress.enddate}`})
      }
    },
    /* Genererer en komma sepereret liste over de værelser der er bestilt (eks: '1,D,3') 
     * tager this.$store.getters.bookingInProgress.needs som argument 
     */
    findOrderedRooms(rooms) {
      var orderedRooms = [];
      for(var key in rooms) {
        if(rooms.hasOwnProperty(key)) {
          if(rooms[key] > 0) {
            orderedRooms.push(key);
          }
        }
      }
    return orderedRooms.join(',');
    },
    /**
     * Udvælger de første ledige værelser af hver type, og i det korrekte antal, der findes i 'needs'
     * Hvis 'needs' er: {"1":1,"3":2,"D":1} returneres f.eks {11, 31, 32, 21} (1, 3, 3, D værelser)
     */
    findFirstRooms(rooms, needs) {
      var unique = [];
      var needsCopy = JSON.parse(JSON.stringify(needs));

      for (let key in needsCopy) {  // Loop igennem alle værelsestyper vi skal bruge
        while(needsCopy[key] >= needs[key] && needsCopy[key] > 0) {    // Looper igennem hvert antal af hver type værelse vi skal booke
          for (var r=0; r < rooms.length; r++) {  // Loop igennem liste af ledige værelser
            if (rooms[r].short_code == key) { // Vi har fundet et værelse...
              if(!unique.includes(rooms[r].id_room) && needsCopy[key] > 0) {  // Hvis værelset ikke ligger der allerede
                unique.push(rooms[r].id_room);          // Så append det til array af valgte værelser
                needsCopy[key]--;                       // Og notér at vi nu skal finde én mindre af denne type
              }
            }
          }
        }
      }
      console.log('Valgte værelser: '+JSON.stringify(unique));
      var name = 'wants';  // Det objekt i 'bookingInProgress' vi vil ændre
      var value = unique;  // Den værdi der skal sættes i 'bookingInProgress'
      this.$store.dispatch("addToCart", {name, value}); // Gem de valgte værelser i vuex store
    },
    skip() {
      //console.log('Tester om vi skal springe ja/nej-siden over...');

      // Hvis der er valgt "Best Western Kastrup" skal valg af værelse altid springes over
      if(this.$store.getters.bookingInProgress.hotel === '2771') {
          this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
          this.$router.replace({ path: "ekstra" });
      } else {
        if(this.$store.getters.bookingInProgress.roomtype === 'parkering') {              // Vi springer altid 'valg af værelse' over ved parkering
          this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
          this.$router.replace({ path: "ekstra" });
        } else if(this.$store.getters.bookingInProgress.roomtype === 'selskabslokale') {  // Vi springer også altid 'valg af værelse' over ved selskabslokale
          this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
          this.$router.replace({ path: "ekstra" });
        } else if(this.$store.getters.bookingInProgress.roomtype === 'moedelokale') {     // Mødelokale springes kun over hvis der kun er 1 tilgængeligt
          if(Object.keys(this.$store.getters.availableRooms).length === 1) {
            this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
            this.$router.replace({ path: "ekstra" });
          }
        } else if(this.$store.getters.bookingInProgress.roomtype === 'vaerelse') {        // Værelse springes kun over hvis der kun er 1 tilgængeligt
          if(Object.keys(this.$store.getters.availableRooms).length === 1) {
            this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
            this.$router.replace({ path: "ekstra" });
          }
        } else {
          // Catch-all til at vi ikke springer over
          console.log('Ved catch-all springer vi ikke over');
        }
      }
      // test om vi skal springe denne side over - hvis ja:
      //this.findFirstRooms(this.$store.getters.availableRooms, this.$store.getters.bookingInProgress.needs);
      // redirect to ekstra
      // hvis ikke - så gør intet.
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 400%;
  margin-bottom: 120px;
  font-weight: normal;
}

a {
  text-decoration: none;
}

.tilbage {
    text-transform: none;
    color: black;
}

.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.roomBox {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 200px;
  height: 110px;
  box-sizing: border-box;
  text-decoration:none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 0px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 200%;
  font-weight: normal;
}

.hvisnej {
  text-transform: none;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Mindre overskrift */
  h1 {
    font-size: 200%;
    margin-bottom: 50px;
  }

  /* Mindre afstand mellem kasser */
  .roomBox {
    margin-bottom: 40px;
  }

}

</style>
